// extracted by mini-css-extract-plugin
export var menuIcon = "_u3-0";
export var menuIconInline = "_u3-1";